export const isWhatsappButton = (pathname: string) => {
  if (pathname === '/' || pathname.includes('/maquina-de-cartao')) {
    return 1;
  }

  return 0;
};
